import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';

import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import stammdatenService from '../services/stammdatenService.js';
import { displayArray, resetDialogInput } from '../util.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.clickErstelleJournalVorwert = clickErstelleJournalVorwert;
window.myHandlers.editiereJournalVorwerte = editiereJournalVorwerte;
window.myHandlers.confirmJournalVorwertDialog = confirmJournalVorwertDialog;
window.myHandlers.clickLoescheJournalVorwertDialog = clickLoescheJournalVorwertDialog;
window.myHandlers.pruefeVorwertSteuerbrutto = pruefeVorwertSteuerbrutto;
window.myHandlers.pruefeVorwertSvBrutto = pruefeVorwertSvBrutto;


// nach Zeitraum absteigend sortiert (neuester Monat zuerst), siehe leseMitarbeiterJournalHistorie
let letzteHistorie = [];
// MitarbeiterID/Zeitraum des Vorwerts, der aktuell im Dialog bearbeitet wird (null = neuer Vorwert)
let bearbeiteterVorwert = null;

async function ladeHistorie(aktuellerMA) {
    if (!_.isEmpty(aktuellerMA)) {
        const historie = await stammdatenService.leseJournalHistorieMitarbeiter(aktuellerMA._id);
        letzteHistorie = historie;
        const parentHTML = document.getElementById('ma-jh-panel');
        displayArray(historie, 'ma-jh-', parentHTML);
    }
}

async function clickErstelleJournalVorwert() {
    const ersterHistorieMonat = _.isEmpty(letzteHistorie) ? null : _.last(letzteHistorie).Zeitraum;
    const vorschlagMonat = ersterHistorieMonat ? dayjs(ersterHistorieMonat).subtract(1, 'month') : window.myVars.aktuellesMonatsDatum;
    document.getElementById('ma-jh-vorwert-zeitraum').value = vorschlagMonat.format('YYYY-MM');
    const input = await SystemDialogService.instance.displayAsync('ma-jh-vorwert-dialog');
    if (input.success) {
        const result = await stammdatenService.erstelleJournalVorwertMA(
					stammdatenService.aktuellerMitarbeiter._id,
					input.data.Zeitraum,
					input.data.EgfzSchnittwert,
					input.data.AGKostenSchnittwert,
					input.data.Arbeitsstunden,
					input.data.Arbeitstage,
					input.data.Steuerbrutto,
					input.data.SvBrutto,
					input.data.EinmalzahlungST,
					input.data.EinmalzahlungSV,
					input.data.Gesamtbrutto,
					input.data.AgGesamtkosten,
					input.data.SvTage,
					input.data.Steuertage
				);
        if (result) {
            await ladeHistorie(stammdatenService.aktuellerMitarbeiter);
        }
        resetDialogInput('ma-jh-vorwert-dialog');
    }
}

async function editiereJournalVorwerte(mitarbeiterID, zeitraum) {
    const eintrag = _.findWhere(letzteHistorie, { Zeitraum: zeitraum });
    if (_.isEmpty(eintrag)) {
        return;
    }
    bearbeiteterVorwert = { mitarbeiterID, zeitraum };
    document.getElementById('ma-jh-vorwert-zeitraum').value = dayjs(zeitraum).format('YYYY-MM');
    document.getElementById('ma-jh-vorwert-zeitraum').disabled = true;
    document.getElementById('ma-jh-vorwert-egfz').value = eintrag.Mitarbeiter.Monatswerte.EGFZBruttoStunde;
    document.getElementById('ma-jh-vorwert-agkosten').value = eintrag.Mitarbeiter.Ergebnis.AgGesamtkostenStunde;
    document.getElementById('ma-jh-vorwert-arbeitsstunden').value = eintrag.Mitarbeiter.Monatswerte.Arbeitsstunden;
    document.getElementById('ma-jh-vorwert-arbeitstage').value = eintrag.Mitarbeiter.Monatswerte.Arbeitstage;
    document.getElementById('ma-jh-vorwert-gesamtbrutto').value = eintrag.Mitarbeiter.Ergebnis.Gesamtbrutto ?? 0;
    document.getElementById('ma-jh-vorwert-aggesamtkosten').value = eintrag.Mitarbeiter.Ergebnis.AgGesamtkosten ?? 0;
    document.getElementById('ma-jh-vorwert-steuerbrutto').value = eintrag.Mitarbeiter.Ergebnis.SteuerbruttoAN ?? 0;
    document.getElementById('ma-jh-vorwert-svbrutto').value = eintrag.Mitarbeiter.Ergebnis.SvBruttoAN ?? 0;
    document.getElementById('ma-jh-vorwert-einmalzahlung-st').value = eintrag.Mitarbeiter.Monatswerte.EinmalzahlungMonatST ?? 0;
    document.getElementById('ma-jh-vorwert-einmalzahlung-sv').value = eintrag.Mitarbeiter.Monatswerte.EinmalzahlungMonatSV ?? 0;
    document.getElementById('ma-jh-vorwert-steuertage').value = eintrag.Mitarbeiter.Monatswerte.Steuertage;
    document.getElementById('ma-jh-vorwert-svtage').value = eintrag.Mitarbeiter.Monatswerte.SvTage;
    document.getElementById('ma-jh-vorwert-dialog-titel').innerText = 'Journal Vorwert Bearbeiten';
    document.getElementById('ma-jh-vorwert-dialog-bestaetigen').innerText = 'Speichern';
    document.getElementById('ma-jh-vorwert-dialog-loeschen').classList.remove('hidden');
    const input = await SystemDialogService.instance.displayAsync('ma-jh-vorwert-dialog');
    if (input.success) {
        const result = await stammdatenService.bearbeiteJournalVorwertMA(
					mitarbeiterID,
					input.data.Zeitraum,
					input.data.EgfzSchnittwert,
					input.data.AGKostenSchnittwert,
					input.data.Arbeitsstunden,
					input.data.Arbeitstage,
					input.data.Steuerbrutto,
					input.data.SvBrutto,
					input.data.EinmalzahlungST,
					input.data.EinmalzahlungSV,
					input.data.Gesamtbrutto,
					input.data.AgGesamtkosten,
					input.data.SvTage,
					input.data.Steuertage
				);
        if (result) {
            await ladeHistorie(stammdatenService.aktuellerMitarbeiter);
        }
    }
    schliesseVorwertDialog();
}

async function clickLoescheJournalVorwertDialog() {
    if (_.isEmpty(bearbeiteterVorwert)) {
        return;
    }
    const result = await stammdatenService.entferneJournalVorwertMA(bearbeiteterVorwert.mitarbeiterID, bearbeiteterVorwert.zeitraum);
    if (result) {
        SystemDialogService.instance.abort();
        await ladeHistorie(stammdatenService.aktuellerMitarbeiter);
    }
}

function schliesseVorwertDialog() {
    document.getElementById('ma-jh-vorwert-zeitraum').disabled = false;
    document.getElementById('ma-jh-vorwert-dialog-titel').innerText = 'Journal Vorwert Anlegen';
    document.getElementById('ma-jh-vorwert-dialog-bestaetigen').innerText = 'Erstellen';
    document.getElementById('ma-jh-vorwert-dialog-loeschen').classList.add('hidden');
    resetDialogInput('ma-jh-vorwert-dialog');
    bearbeiteterVorwert = null;
}

function parseOptionalFloat(value) {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? undefined : parsed;
}

// wird ein Bruttowert eingetragen, ohne dass zuvor schon Tage gesetzt wurden, schlagen wir 30 Tage vor
function pruefeVorwertSteuerbrutto(input) {
    const steuertageInput = document.getElementById('ma-jh-vorwert-steuertage');
    if (parseFloat(input.value) > 0 && parseFloat(steuertageInput.value) === 0) {
        steuertageInput.value = 30;
    }
}

function pruefeVorwertSvBrutto(input) {
    const svtageInput = document.getElementById('ma-jh-vorwert-svtage');
    if (parseFloat(input.value) > 0 && parseFloat(svtageInput.value) === 0) {
        svtageInput.value = 30;
    }
}

function confirmJournalVorwertDialog() {
    const dialogHtml = document.getElementById('ma-jh-vorwert-dialog');
    SystemDialogService.instance.confirm({
        Zeitraum: dayjs(dialogHtml.querySelector('#ma-jh-vorwert-zeitraum').value).format('YYYY-MM-DD'),
        EgfzSchnittwert: parseFloat(dialogHtml.querySelector('#ma-jh-vorwert-egfz').value),
        AGKostenSchnittwert: parseFloat(dialogHtml.querySelector('#ma-jh-vorwert-agkosten').value),
        Arbeitsstunden: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-arbeitsstunden').value),
        Arbeitstage: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-arbeitstage').value),
        Steuerbrutto: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-steuerbrutto').value),
        SvBrutto: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-svbrutto').value),
        EinmalzahlungST: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-einmalzahlung-st').value),
        EinmalzahlungSV: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-einmalzahlung-sv').value),
        Gesamtbrutto: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-gesamtbrutto').value),
        AgGesamtkosten: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-aggesamtkosten').value),
        SvTage: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-svtage').value),
        Steuertage: parseOptionalFloat(dialogHtml.querySelector('#ma-jh-vorwert-steuertage').value),
    });
}

export {
    ladeHistorie
};
